module.exports = __webpack_public_path__ + "static/media/hipercard.e03f8097.png";